import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import feathersClient from '../../../../apiClient';

export const signUpUserThunk = createAsyncThunk('auth/signUpUser', async (data) => {
  const user = {
    username: data.email,
    password: data.password,
    person: {
      first_name: data.first_name,
      last_name: data.last_name,
      ...data.person,
    },
  };
  return feathersClient.service('login').create(user);
});

const signUpReducers = {
  [signUpUserThunk.pending]: (state) => {
    state.loading = true;
    state.error = false;
  },
  [signUpUserThunk.rejected]: (state, action) => {
    state.loading = false;
    state.error = action.error.message;
  },
  [signUpUserThunk.fulfilled]: (state) => {
    state.loading = false;
    state.error = false;
  },
};

export const signOutUserThunk = createAsyncThunk('auth/signOutUser', async () => {
  await feathersClient.logout();
});

const signOutReducers = {
  [signOutUserThunk.pending]: (state) => {
    state.loading = true;
    state.error = false;
  },
  [signOutUserThunk.rejected]: (state, action) => {
    state.loading = false;
    state.error = action.error.message;
  },
  [signOutUserThunk.fulfilled]: (state) => {
    state.loading = false;
    state.error = false;
    state.person = null;
    state.userID = null;
    state.token = null;
  },
};

export const forgotPasswordThunk = createAsyncThunk('auth/forgotPassword', async (email) => {
  await feathersClient.service('authmanagement').create({
    action: 'sendResetPwd',
    value: { email },
  });
});

const forgotPasswordReducers = {
  [forgotPasswordThunk.pending]: (state) => {
    state.loading = true;
    state.error = false;
  },
  [forgotPasswordThunk.rejected]: (state, action) => {
    state.loading = false;
    state.error = action.error.message;
  },
  [forgotPasswordThunk.fulfilled]: (state) => {
    state.loading = false;
    state.error = false;
  },
};

export const resetPasswordThunk = createAsyncThunk('auth/resetPassword', async (data) => {
  const { token, password } = data;
  await feathersClient.service('authmanagement').create({
    action: 'resetPwdLong',
    value: { token, password },
  });
});

const resetPasswordReducers = {
  [resetPasswordThunk.pending]: (state) => {
    state.loading = true;
    state.error = false;
  },
  [resetPasswordThunk.rejected]: (state, action) => {
    state.loading = false;
    state.error = action.error.message;
  },
  [resetPasswordThunk.fulfilled]: (state) => {
    state.loading = false;
    state.error = false;
  },
};

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    loading: null,
    error: null,
    userID: null,
    token: null,
    person: null,
  },
  reducers: {},
  extraReducers: {
    ...signUpReducers,
    ...signOutReducers,
    ...forgotPasswordReducers,
    ...resetPasswordReducers,
  },
});

export const selectAuthError = createSelector(
  (state) => state.auth.error,
  (error) => {
    if (error !== null) return error;
    return undefined;
  },
);

export const selectIsAuthenticated = createSelector(
  (state) => state.auth.userID,
  (state) => state.auth.token,
  (userID, token) => userID !== null && token !== null,
);

export default authSlice.reducer;
